import React from "react";
import { Container, Row } from "shards-react";

import { BrowserRouter as Router } from "react-router-dom";
import { makeMainRoutes } from "./router/routes";
import customHistory from './utils/history';
const Routes = makeMainRoutes();
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Assets Css
import "./assets/css/all.css";
import "./assets/css/style.min.css";
import "./assets/sass/index.scss";

const App = () => {
    return (
        <Container fluid>
            <ToastContainer autoClose={6000} />
            <Row>
                <Router history={customHistory}>
                    <Routes/>
                </Router>
            </Row>
        </Container>
    );
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js